export default "__VITE_ASSET__CZnqVPcI__"